// @ts-ignore
process.hrtime = () => [0, 0];
